import { useLayoutEffect, useRef } from "react";
import { AutoCompleteItem } from "../autocomplete/interface";
import CloseIcon from "../icons/CloseIcon";

function FormControlButtonSmall<T>(props: {
  remove: () => void;
  selectedItem: AutoCompleteItem<T>;
  disabled?: boolean;
  focusOnMount?: boolean;
}) {
  const { remove, selectedItem, disabled, focusOnMount } = props;
  const ref = useRef<HTMLButtonElement>(null);
  useLayoutEffect(() => {
    if (focusOnMount && ref.current) {
      ref.current.focus();
    }
  }, [focusOnMount]);
  return (
    <button
      ref={ref}
      type="button"
      className={`form-control d-flex align-items-center${
        disabled ? " disabled" : ""
      }`}
      onClick={() => {
        if (!disabled) remove();
      }}
    >
      <span>{selectedItem.header}</span>
      <span className="ms-auto text-muted d-flex align-items-center">
        <CloseIcon height={18} />
      </span>
    </button>
  );
}

export default FormControlButtonSmall;
